var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurgical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m466-376.77-93.08-93.08 281.23-281.23q9.54-9.69 22.66-9.69 13.11 0 22.81 9.69l47.61 47.62q9.69 9.54 9.69 22.65 0 13.12-9.69 22.81L466-376.77Zm0-57.08 248-247-37-37-247 248 36 36Zm47.85 242.31 40-40h331.53v40H513.85Zm-285.47.77q-27.9 0-53.68-8t-48.55-23.85l204.23-204 75.54 75.54q8.98 8.5 14.11 19.42 5.12 10.93 5.12 23.06 0 12.14-4.92 23.38-4.92 11.25-13.54 19.76l-19 19.77q-26.61 27.38-62.19 41.15t-73.12 13.77h-24Zm0-40h24q30 0 58-11.5t49-32.5l19-19q6-6 5.62-14.38-.38-8.39-7.15-15.16l-46.47-46.46-134.46 133.46q5.7 2.77 14.96 4.16 9.27 1.38 17.5 1.38ZM714-680.85l-37-37 37 37ZM330.38-369.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgical);
export default __webpack_public_path__ + "static/media/surgical.de20f7677c55d1c662deb7e60e7f7fd5.svg";
export { ForwardRef as ReactComponent };